// This page should show when the oauth process fails, which happens in the end of the oauth process.
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { useStyles } from './styles.js';
import ContentContainer from '../../components/contentContainer';
import WidgetDialog from '../../components/dialogs';
import TransitionAvatar from '../../components/transitionAvatar';
import TitleHeader from '../../components/titleHeader';
import useWidgetTheme from '../../../commons/widgetTheme';
import CommonImages from '../../../commons/images';

import usePageTransitions from '../../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../../store/models/animations/actions/transitions';

const error = {
    message: 'Error getting access token from google: oauth2: "invalid_grant""Bad Request"',
    refId: '6ff44e94-70d8-4988-851b-a74b637b148d',
}

function OauthFailed (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    usePageTransitions({
        elementName: TransitionViewNames.OAUTH_FAILED_VIEW,
        viewAnimation,
    });

    return (
        <React.Fragment>
            <ContentContainer
                viewAnimation={viewAnimation} 
            >
                <WidgetDialog
                    isOauthTalking={true}
                    isShowBackButton={false}
                    name={TransitionViewNames.OAUTH_FAILED_VIEW}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                >
                    <TransitionAvatar
                        marginTop={'48px'}
                        calendarLogoURL={CommonImages.GOOGLE_LOGO}
                        clientLogoURL={widget?.logo}
                        loadingIcon={CommonImages.LIGHTING}
                        isOauthFailing={true}
                    />

                    <Grid className={classes.titleHeader}>
                        <TitleHeader
                            widget={widget}
                            widgetTheme={widgetTheme}
                            title={'Calendar could not be connected'}
                            error={error}
                        />
                    </Grid>

                    <Grid className={classes.contentBody}>
                        <Typography
                            className={classes.errorMsg}
                            variant={'subtitle1'}
                        >
                            {error.message}
                        </Typography>
                        <Typography variant={'body2'}>
                            {`Ref ID: ${error?.refId}`}
                        </Typography>
                        <Button
                            className={classes.backButton}
                            variant="contained"
                        >
                            {`Back to ${widget?.organization}`}
                        </Button>
                        <a 
                            className={classNames([classes.powered, 'ecal-logo'])}
                            href="https://ecal.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                             <img src={CommonImages.ECAL_FOOTER_LOGO} alt="Footer Logo" />
                        </a>
                    </Grid>
                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

OauthFailed.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};


export default observer(OauthFailed);